import React from "react";
import {ExportMobilisConfigurationContainer} from "./ExportMobilisConfigurationContainer";

export const ExportMobilisConfigurationScreen = (): React.ReactElement => {

    return <ExportMobilisConfigurationContainer/>;
}